// extracted by mini-css-extract-plugin
module.exports = {"localizationButton":"LocalizedButton_localizationButton__NFztD","localizationLang":"LocalizedButton_localizationLang__hDHe_","disabled":"LocalizedButton_disabled__535YF"};